import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Sync a free-form string value to a URL search param.
 * Pass `null` to remove the key. Other params are preserved.
 */
export function useSearchParamState(
  paramName: string,
): [string | null, (value: string | null, opts?: { replace?: boolean }) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(paramName);

  const setValue = useCallback(
    (nextValue: string | null, opts?: { replace?: boolean }) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (nextValue === null || nextValue === '') {
            next.delete(paramName);
          } else {
            next.set(paramName, nextValue);
          }
          return next;
        },
        { replace: opts?.replace ?? false },
      );
    },
    [paramName, setSearchParams],
  );

  return [value, setValue];
}
